import { render, staticRenderFns } from "./RmpLegalPersonDetails.vue?vue&type=template&id=33b14cde"
import script from "./RmpLegalPersonDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpLegalPersonDetails.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports